import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronRight, Home, Monitor, BarChart3 } from 'lucide-react';

const PDVBreadcrumb = () => {
  const location = useLocation();
  
  const breadcrumbMap = {
    '/dashboard': { label: 'Dashboard', icon: Home },
    '/dashboard/pdv': { label: 'PDV - Vendas', icon: Monitor },
    '/dashboard/pdv/dashboard': { label: 'Dashboard PDV', icon: Monitor },
    '/dashboard/pdv/reports': { label: 'Relatórios PDV', icon: BarChart3 },
  };
  
  const getBreadcrumbs = () => {
    const paths = location.pathname.split('/').filter(Boolean);
    const breadcrumbs = [];
    
    for (let i = 0; i < paths.length; i++) {
      const path = '/' + paths.slice(0, i + 1).join('/');
      const breadcrumb = breadcrumbMap[path];
      
      if (breadcrumb) {
        breadcrumbs.push({
          path,
          label: breadcrumb.label,
          icon: breadcrumb.icon,
          isLast: i === paths.length - 1
        });
      }
    }
    
    return breadcrumbs;
  };
  
  const breadcrumbs = getBreadcrumbs();
  
  // Não mostrar breadcrumb se houver apenas um item ou se não estiver em página do PDV
  if (breadcrumbs.length <= 1 || !location.pathname.includes('/pdv')) {
    return null;
  }
  
  return (
    <nav className="flex items-center space-x-2 text-sm text-gray-600 mb-6">
      {breadcrumbs.map((breadcrumb, index) => {
        const Icon = breadcrumb.icon;
        
        return (
          <React.Fragment key={breadcrumb.path}>
            {index > 0 && (
              <ChevronRight className="w-4 h-4 text-gray-400" />
            )}
            
            {breadcrumb.isLast ? (
              <span className="flex items-center text-gray-900 font-medium">
                <Icon className="w-4 h-4 mr-1" />
                {breadcrumb.label}
              </span>
            ) : (
              <Link 
                to={breadcrumb.path}
                className="flex items-center hover:text-blue-600 transition-colors"
              >
                <Icon className="w-4 h-4 mr-1" />
                {breadcrumb.label}
              </Link>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
};

export default PDVBreadcrumb;
